export const getRemSize = (fontSize: number, screenSize = 'desktop'): string => {
  if (screenSize === 'desktop') {
    return `${fontSize / 16}rem`;
  }
  return `${fontSize / 18}rem`;
};
